import useGeneralDelivery from '../../../../../../../../hooks/useGeneralDelivery';
import { useHomeAddress } from '../../../../../../providers/HomeAddressProvider';
import { usePersonalInformation } from '../../../../../../providers/PersonalInformationProvider';

export default function useSameAddress() {
    const {
        personalInformation: {
            MailingAddressLine1,
            MailingAddressLine2,
            MailingCity,
            MailingState,
            MailingZipCode,
        },
    } = usePersonalInformation();
    const {
        homeAddress: {
            HomeAddressLine1,
            HomeAddressLine2,
            HomeCity,
            HomeState,
            HomeZipCode,
        },
        showHomeAddress,
    } = useHomeAddress();
    const { matchGeneralDelivery } = useGeneralDelivery();

    if (!matchGeneralDelivery(MailingAddressLine1) && !showHomeAddress) {
        return true;
    }

    if (MailingAddressLine1 !== HomeAddressLine1) {
        return false;
    }

    if (MailingAddressLine2 !== HomeAddressLine2) {
        return false;
    }

    if (MailingCity !== HomeCity) {
        return false;
    }

    if (MailingState !== HomeState) {
        return false;
    }

    if (MailingZipCode !== HomeZipCode) {
        return false;
    }

    return true;
}
